import { Box, Paper } from "@mui/material";
import { SoftwareTable } from "~/pages/inventory/components/AssetSoftware/AssetSoftwareTable";
import { AssetSoftwarePackagesType } from "~/pages/inventory/components/AssetSoftware/types";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";
import { Paginate, PaginateProps } from "~/components/pagination/paginate";
import { useSort } from "../../hooks/useSort";

type AssetSoftwareDataProps = {
  scope: SpaceOrWorkspaceScope;
  sort: ReturnType<typeof useSort>;
  assetMrn: string;
  packageScores: AssetSoftwarePackagesType | null | undefined;
  paginationProps?: PaginateProps;
};

export const AssetSoftwareData = ({
  scope,
  sort,
  assetMrn,
  packageScores,
  paginationProps,
}: AssetSoftwareDataProps) => {
  const packages =
    packageScores?.edges?.flatMap((e) =>
      e.node && e.node.__typename === "PackageFinding" ? e.node : [],
    ) || [];

  return (
    <Box>
      <Paper sx={{ my: 3 }}>
        <SoftwareTable
          scope={scope}
          packages={packages}
          sort={sort}
          assetMrn={assetMrn}
        />
        {paginationProps && <Paginate {...paginationProps} />}
      </Paper>
    </Box>
  );
};
